import { BackgroundColor } from '../../../lib/types/background'
import styles from './image-scroller.module.scss'
import { bgTo2024Map } from '../../page-section/theme'

export const getGradientBgClassname = (backgroundColor = BackgroundColor.Transparent, convertTo2024 = false) => {
  const bgColor = convertTo2024 ? bgTo2024Map[backgroundColor] : backgroundColor
  return bgStyleMap[bgColor]
}

const bgStyleMap: { [key in BackgroundColor]: string } = {
  [BackgroundColor.Transparent]: '',
  [BackgroundColor.N0]: styles.imageScrollern0,
  [BackgroundColor.N1]: styles.imageScrollern1,
  [BackgroundColor.N10]: styles.imageScrollern10,
  [BackgroundColor.N20]: styles.imageScrollern20,
  [BackgroundColor.N30]: styles.imageScrollern30,
  [BackgroundColor.N40]: styles.imageScrollern40,
  [BackgroundColor.N50]: styles.imageScrollern50,
  [BackgroundColor.N60]: styles.imageScrollern60,
  [BackgroundColor.N70]: styles.imageScrollern70,
  [BackgroundColor.N80]: styles.imageScrollern80,
  [BackgroundColor.N90]: styles.imageScrollern90,
  [BackgroundColor.N100]: styles.imageScrollern100,

  [BackgroundColor.G1]: styles.imageScrollerg1,
  [BackgroundColor.G10]: styles.imageScrollerg10,
  [BackgroundColor.G20]: styles.imageScrollerg20,
  [BackgroundColor.G30]: styles.imageScrollerg30,
  [BackgroundColor.G40]: styles.imageScrollerg40,
  [BackgroundColor.G50]: styles.imageScrollerg50,
  [BackgroundColor.G60]: styles.imageScrollerg60,
  [BackgroundColor.G70]: styles.imageScrollerg70,
  [BackgroundColor.G80]: styles.imageScrollerg80,
  [BackgroundColor.G90]: styles.imageScrollerg90,
  [BackgroundColor.G100]: styles.imageScrollerg100,

  [BackgroundColor.B1]: styles.imageScrollerb1,
  [BackgroundColor.B10]: styles.imageScrollerb10,
  [BackgroundColor.B20]: styles.imageScrollerb20,
  [BackgroundColor.B30]: styles.imageScrollerb30,
  [BackgroundColor.B40]: styles.imageScrollerb40,
  [BackgroundColor.B50]: styles.imageScrollerb50,
  [BackgroundColor.B60]: styles.imageScrollerb60,
  [BackgroundColor.B70]: styles.imageScrollerb70,
  [BackgroundColor.B80]: styles.imageScrollerb80,
  [BackgroundColor.B1001]: styles.imageScrollerb1001,

  [BackgroundColor.C1]: styles.imageScrollerc1,
  [BackgroundColor.C10]: styles.imageScrollerc10,
  [BackgroundColor.C30]: styles.imageScrollerc30,
  [BackgroundColor.C40]: styles.imageScrollerc40,
  [BackgroundColor.C50]: styles.imageScrollerc50,
  [BackgroundColor.C60]: styles.imageScrollerc60,

  [BackgroundColor.YB1]: styles.imageScrolleryb1,
  [BackgroundColor.YB10]: styles.imageScrolleryb10,
  [BackgroundColor.YB20]: styles.imageScrolleryb20,
  [BackgroundColor.YB30]: styles.imageScrolleryb30,
  [BackgroundColor.YB40]: styles.imageScrolleryb40,
  [BackgroundColor.YB50]: styles.imageScrolleryb50,

  [BackgroundColor.I1]: styles.imageScrolleri1,
  [BackgroundColor.I10]: styles.imageScrolleri10,
  [BackgroundColor.I20]: styles.imageScrolleri20,
  [BackgroundColor.I30]: styles.imageScrolleri30,
  [BackgroundColor.I40]: styles.imageScrolleri40,
  [BackgroundColor.I50]: styles.imageScrolleri50,
  [BackgroundColor.I60]: styles.imageScrolleri60,
  [BackgroundColor.I70]: styles.imageScrolleri70,
  [BackgroundColor.I80]: styles.imageScrolleri80,

  [BackgroundColor.S1]: styles.imageScrollers1,
  [BackgroundColor.S10]: styles.imageScrollers10,
  [BackgroundColor.S20]: styles.imageScrollers20,
  [BackgroundColor.S30]: styles.imageScrollers30,
  [BackgroundColor.S40]: styles.imageScrollers40,
  [BackgroundColor.S50]: styles.imageScrollers50,
  [BackgroundColor.S60]: styles.imageScrollers60,
  [BackgroundColor.S70]: styles.imageScrollers70,
  [BackgroundColor.S80]: styles.imageScrollers80,

  [BackgroundColor.M1]: styles.imageScrollerm1,
  [BackgroundColor.M10]: styles.imageScrollerm10,
  [BackgroundColor.M30]: styles.imageScrollerm30,
  [BackgroundColor.M40]: styles.imageScrollerm40,
  [BackgroundColor.M60]: styles.imageScrollerm60,
  [BackgroundColor.M70]: styles.imageScrollerm70,

  [BackgroundColor.L1]: styles.imageScrollerl1,
  [BackgroundColor.L10]: styles.imageScrollerl10,
  [BackgroundColor.L20]: styles.imageScrollerl20,
  [BackgroundColor.L30]: styles.imageScrollerl30,
  [BackgroundColor.L40]: styles.imageScrollerl40,
  [BackgroundColor.L50]: styles.imageScrollerl50,

  [BackgroundColor.W0_24]: styles.imageScrollerw0_24,

  [BackgroundColor.N0_24]: styles.imageScrollern0_24,
  [BackgroundColor.N100_24]: styles.imageScrollern100_24,

  [BackgroundColor.G60_24]: styles.imageScrollerg60_24,
  [BackgroundColor.G100_24]: styles.imageScrollerg100_24,

  [BackgroundColor.O1001_24]: styles.imageScrollero1001_24,
  [BackgroundColor.O1002_24]: styles.imageScrollero1002_24,

  [BackgroundColor.B80_24]: styles.imageScrollerb80_24,
  [BackgroundColor.B1001_24]: styles.imageScrollerb1001_24,

  [BackgroundColor.BT1001_24]: styles.imageScrollerbt1001_24,

  [BackgroundColor.T90_24]: styles.imageScrollert90_24,

  [BackgroundColor.P90_24]: styles.imageScrollerp90_24,
  [BackgroundColor.P100_24]: styles.imageScrollerp100_24,
}
